import { render, staticRenderFns } from "./AccountSeller.vue?vue&type=template&id=7223c5c6&scoped=true&"
import script from "./AccountSeller.vue?vue&type=script&lang=js&"
export * from "./AccountSeller.vue?vue&type=script&lang=js&"
import style0 from "./AccountSeller.vue?vue&type=style&index=0&id=7223c5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7223c5c6",
  null
  
)

export default component.exports